// extracted by mini-css-extract-plugin
export default {"payInfo":"u8M13aUO--styles_payInfo__+ESqy","brandIcon":"u8M13aUO--styles_brandIcon__ZxCWp","cardBrand":"u8M13aUO--styles_cardBrand__3yIJj"};